import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB71XzJPnFLUip9rOTmL4LQSAfosw89WTE",
  authDomain: "jamas-lens.firebaseapp.com",
  projectId: "jamas-lens",
  storageBucket: "jamas-lens.firebasestorage.app",
  messagingSenderId: "81722012396",
  appId: "1:81722012396:web:f805e8200b4c29b33aebc9",
  measurementId: "G-3C5FS0GK2C"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
